import React, { useEffect } from 'react'
import { css } from '@emotion/core'
import * as ReportModel from '@/models/report'
import { FormContainer, FormInputBlock, FormInputRadioWrapper } from '@/components/molecules/reports-manager/form-container'
import { Select } from '@/components/atoms/select'
import { Select as AntSelect } from 'antd'
import { Controller, UseFormReturn, useWatch } from 'react-hook-form'
import { DateRangeField } from '@/components/molecules/date-range-field'
import { ReportFormType } from '@/features/report-manager/report-manager-slice'

export const CustomPeriodReportForm: React.FC<{ formReturn: UseFormReturn<ReportFormType, any> }> = props => {
  const { control, handleSubmit, setValue } = props.formReturn
  const watchType = useWatch({ control, name: 'type' })
  const watchPeriodStartDate = useWatch({ control, name: 'period.startDate' })
  const watchPeriodEndDate = useWatch({ control, name: 'period.endDate' })

  useEffect(() => {
    if (!ReportModel.periodReportTypes.includes(watchType)) {
      setValue('type', ReportModel.periodReportTypes[0])
    }
  }, [])

  return (
    <FormContainer onSubmit={handleSubmit}>
      <FormInputBlock title="レポート種類">
        <Controller
          name="type"
          control={control}
          render={({ field: { onChange, value } }) => (
            <Select value={value} onChange={onChange} customStyle={css({ paddingBottom: 0, width: 290 })}>
              {ReportModel.periodReportTypes.map(type => (
                <AntSelect.Option key={type} value={type}>
                  {ReportModel.ReportTypeNames[type]}
                </AntSelect.Option>
              ))}
            </Select>
          )}
        />
      </FormInputBlock>

      <FormInputBlock title="期間">
        <DateRangeField
          beginDate={watchPeriodStartDate}
          endDate={watchPeriodEndDate}
          changeRangeDate={(beginDate: string, endDate: string) => {
            setValue('period.startDate', beginDate)
            setValue('period.endDate', endDate)
          }}
        />
      </FormInputBlock>

      <FormInputBlock title="出力形式">
        <Controller
          name="format"
          control={control}
          render={({ field: { onChange, value } }) => (
            <FormInputRadioWrapper value={value} items={ReportModel.formatRadioItems} onChange={onChange} />
          )}
        />
      </FormInputBlock>

      {ReportModel.enabledTax.includes(watchType) && (
        <FormInputBlock title="税表示">
          <Controller
            name="isIncludeTax"
            control={control}
            render={({ field: { onChange, value } }) => (
              <FormInputRadioWrapper value={value} items={ReportModel.taxRadioItems} onChange={onChange} />
            )}
          />
        </FormInputBlock>
      )}
    </FormContainer>
  )
}
